import {injectGlobal} from 'styled-components'

injectGlobal `
*{
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}
html,body,#root{
  width: 100%;
  height: 100%;
  min-width: 1200px;
}
`
export default injectGlobal



// WEBPACK FOOTER //
// ./src/assets/styled/global.jsx